<!--P001、P004、P005-->
<template>
  <div class="div_content">
    <div class="cs_margin_top_sm ui_hierarchy">
      <div class="cs_cursor_pointer ui_txt_hierarchy">货品维护</div>
    </div>
    <!--查询栏-->
    <div class="cs_margin_top div_search bg_search cs_padding">
      <div class="cs_title_primary cs_text_default type_info_search">货品</div>
      <input v-model="search.id" class="cs_input cs_radius_lg edtxt_info_search width_280 ui_margin_left_44" placeholder="请输入编号、名称或拼音码">
      <div class="cs_title_primary cs_text_default type_info_search cs_margin_left">货品大类</div>
      <web-select :options="search.serialList"
                  @option-key="updateSerial"
                  v-model="search.serialName"
                  class="cs_input cs_radius_lg edtxt_info_search"></web-select>
      <div class="cs_title_primary cs_text_default type_info_search cs_margin_left">货品小类</div>
      <web-select :options="search.typeList"
                  @option-key="updateType"
                  v-model="search.typeName"
                  class="cs_input cs_radius_lg edtxt_info_search"></web-select>
      <button class="ui_btn_search_yellow btn_search" type="button" @click="btnSearch">查询</button>
      <br>
      <div class="cs_title_primary cs_text_default type_info_search cs_margin_top_sm">启用状态</div>
      <web-select :options="MATERIAL_STATUS_QUERY"
                  @option-key="updateStatus"
                  v-model="search.statusName"
                  class="cs_input cs_radius_lg cs_margin_top_sm edtxt_info_search"></web-select>
    </div>
    <!--表格-->
    <div class="cs_margin_top_sm div_search_result cs_padding_top_lg">
      <div class="div_operation_table">
        <button @click="btnAdd" class="cs_btn cs_btn_sm ui_btn_blue cs_fr cs_margin_left_sm"
                type="button">添加
        </button>
        <button v-show="isStop && isStopShow" @click="btnStart" class="cs_btn cs_btn_sm ui_btn_ghost_blue cs_fr"
                type="button">启用
        </button>
        <button v-show="!isStop && isStopShow" @click="btnStop" class="cs_btn cs_btn_sm ui_btn_ghost_blue cs_fr"
                type="button">停用
        </button>
      </div>
      <div class="cs_margin_top div_table">
        <table class="cs_table cs_td_divider_none" width="100%">
          <thead>
          <tr>
            <th width="40px">序号</th>
            <th width="151px">货品编号</th>
            <th width="232px">货品名称</th>
            <th width="96px">单位</th>
            <th width="142px">规格</th>
            <th width="160px">货品大类</th>
            <th width="160px">货品小类</th>
            <th width="96px">启用状态</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(item,index) in orderList" :class="{ 'cs_tr_selected': item.isSelected}" @click="btnSelectTableTr(item)">
            <td>{{index+1}}</td>
            <td><a @click.stop="$router.push({name:'MaterialDetail', query: {id:item.id}})">{{item.materialNum}}</a></td>
            <td>{{item.materialName}}</td>
            <td>{{item.dcStockUnit}}</td>
            <td>{{item.materialSpecs}}</td>
            <td>{{item.materialSerialName}}</td>
            <td>{{item.materialTypeName}}</td>
            <td>{{MATERIAL_STATUS[item.isStop]}}</td>
          </tr>
          <tr v-for="(item,index) in (PAGE_SIZE-orderList.length)">
            <td v-for="j in 8"></td>
          </tr>
          </tbody>
        </table>
      </div>
      <div class="div_page_download">
        <button @click="btnExport" class="ui_btn_export cs_fl" style="width:80px;"
                type="button">导出
        </button>
        <!--上一页-->
        <button v-show="search.pagination>1" @click="showList(search.pagination < 2?1:search.pagination-1)"
                class="btn_page_up" type="button">
        </button>
        <button v-show="search.pagination<=1" class="btn_page_up_disable" type="button"></button>
        <div class="current_page">{{search.pagination}}</div>
        <div class="oblique_line">/</div>
        <div class="total_page">{{search.totalPage}}</div>
        <!--下一页-->
        <button v-show="search.pagination!==search.totalPage" @click="showList(search.pagination+1)" class="btn_page_down" type="button"></button>
        <button v-show="search.pagination===search.totalPage" class="btn_page_down_disable" type="button"></button>
        <div @click="jump()" class="type_page_jump">跳转至</div>
        <input v-model="search.pageJump" class="txt_page_jump" type="text"
               @keyup="checkPositiveInt($event)" @blur="search.pageJump=checkPositiveInt($event)">
      </div>
    </div>
    <div class="div_bottom"></div>
  </div>
</template>

<script>
  import WebSelect from "../../components/web-select"
  import SearchSelect from "../../components/search-select";
  import {Page, PAGE_SIZE,MATERIAL_STATUS,MATERIAL_STATUS_QUERY} from "../../assets/utils/constants"
  import StorageConst from "../../assets/utils/StorageConst";
  export default {
    name: "MaterialManage",
    components: {SearchSelect, WebSelect},
    data: function () {
      return {
        isStopShow: false,
        isStop: false,
        search: {
          id: this.getStoreItem(StorageConst.LOCAL_PAGE_LIST.MATERIAL_MANAGE,"id", ""),
          serialList: [],
          serialId: this.getStoreItem(StorageConst.LOCAL_PAGE_LIST.MATERIAL_MANAGE,"serialId", 0),
          serialName: this.getStoreItem(StorageConst.LOCAL_PAGE_LIST.MATERIAL_MANAGE,"serialName", ""),
          typeList: [],
          typeId: this.getStoreItem(StorageConst.LOCAL_PAGE_LIST.MATERIAL_MANAGE,"typeId", 0),
          typeName: this.getStoreItem(StorageConst.LOCAL_PAGE_LIST.MATERIAL_MANAGE,"typeName", ""),
          statusId: this.getStoreItem(StorageConst.LOCAL_PAGE_LIST.MATERIAL_MANAGE,"statusId", 0),
          statusName: this.getStoreItem(StorageConst.LOCAL_PAGE_LIST.MATERIAL_MANAGE,"statusName", ""),
          pageJump: "",
          totalPage: "",
          pagination: this.getStoreItem(StorageConst.LOCAL_PAGE_LIST.MATERIAL_MANAGE,"pagination", 1)
        },
        orderList: [],
        selectedId: "",
        selectedName: "",
        PAGE_SIZE: PAGE_SIZE,
        MATERIAL_STATUS: MATERIAL_STATUS,
        MATERIAL_STATUS_QUERY: MATERIAL_STATUS_QUERY,
      }
    },
    created: function () {
      this.showList(this.search.pagination);
      this.showSerial();
    },
    mounted: function() {
    },
    methods: {
      showList(pagination) {
        this.selectedId = "";
        this.selectedName = "";
        this.isStop = false;
        this.isStopShow = false;
        this.$ajax.material.listMaterial.bind(this)(this.search, new Page(PAGE_SIZE, pagination), (data) => {
          //显示列表
          this.search.totalPage = data.data.totalPage;
          this.search.pagination = data.data.pagination;
          let list = data.data.list;
          list.forEach((item) => {
            item.isSelected = false;
          });
          this.orderList = list;
          this.setStoreItem(StorageConst.LOCAL_PAGE_LIST.MATERIAL_MANAGE, JSON.stringify(this.search));
        }, (data) => {
        }, true)
      },
      btnExport(){
        this.$ajax.material.exportMaterial.bind(this)(this.search, (response) => {
          let fileName = "货品单-"+this.getNowDateNoDivider()+".xls";
          this.downloadFileStream(response.data, fileName);
        }, (data) => {
        }, true)
      },
      btnSearch(){
        this.showList(1);
      },
      jump() {
        if (!this.isEmpty(this.search.pageJump)) {
          if(this.search.pageJump>this.search.totalPage){
            this.showList(this.search.totalPage);
          }else {
            this.showList(this.search.pageJump);
          }
        }
      },

      btnSelectTableTr(item){
        let selectedStatus = item.isSelected;
        this.orderList.forEach((item1) => {
          item1.isSelected = false;
        });
        item.isSelected = !selectedStatus;
        if(item.isSelected){
          this.selectedId = item.id;
          this.selectedName = item.materialName;
          this.isStop = item.isStop;
          this.isStopShow = true;
        }else {
          this.selectedId = "";
          this.selectedName = "";
          this.isStop = false;
          this.isStopShow = false;
        }
      },
      btnStop(){
        if(this.isEmpty(this.selectedId)){
          this.$toast("请先选中一条数据");
          return;
        }
        this.$alert("确认停用货品"+this.selectedName+"吗？", (clickConfirm) => {
          if (clickConfirm) {
            this.$ajax.material.stopMaterial.bind(this)(this.selectedId, true, (data) => {
              this.$toast("停用成功");
              this.showList(this.search.pagination);
            }, (data) => {
            }, true)
          }
        }, true);
      },
      btnStart(){
        if(this.isEmpty(this.selectedId)){
          this.$toast("请先选中一条数据");
          return;
        }
        this.$alert("确认启用货品"+this.selectedName+"吗？", (clickConfirm) => {
          if (clickConfirm) {
            this.$ajax.material.stopMaterial.bind(this)(this.selectedId, false, (data) => {
              this.$toast("启用成功");
              this.showList(this.search.pagination);
            }, (data) => {
            }, true)
          }
        }, true);
      },
      btnAdd(){
        this.$router.push({name:'MaterialAdd'});
      },

      failDefault() {

      },
      updateStatus(key) {
        this.search.statusId = key;
      },
      showSerial(){
        this.$ajax.materialType.listMaterialType.bind(this)(0,(data) => {
          //显示列表
          let array = [];
          for (let i = 0; i < data.data.length; i++) {
            array.push({
              key: data.data[i].id,
              value: data.data[i].typeName,
            })
          }
          this.search.serialList = array;
        }, (data) => {
        }, false)
      },
      updateSerial(key) {
        this.search.serialId = key;
        this.search.typeList = [];
        this.search.typeId = 0;
        this.search.typeName = "";
        if(!this.isEmpty(key)){
          this.showType(key);
        }
      },
      showType(id){
        this.$ajax.materialType.listMaterialType.bind(this)(id,(data) => {
          //显示列表
          let array = [];
          for (let i = 0; i < data.data.length; i++) {
            array.push({
              key: data.data[i].id,
              value: data.data[i].typeName,
            })
          }
          this.search.typeList = array;
        }, (data) => {
        }, false)
      },
      updateType(key) {
        this.search.typeId = key;
      },
    },
  }
</script>

<style scoped>
  .width_280{width: 280px;}
</style>



// WEBPACK FOOTER //
// src/page/material/MaterialManage.vue